<template>
  <!-- <div class="foot-box">
        <footer>
            <p>
                <span>
                    网站首页
                </span>
                <span>
                    |
                </span>
                <span>
                    盟务要闻
                </span>
            </p>
            <p>
                <span>
                    网站E-mail：2369435125@qq.com
                </span>
                <span>
                    联系电话：15185063680
                </span>
            </p>
            <p>
                <span>版权所有：中国民主同盟贵州省委员会</span>
                <span>黔ICP备14006765号</span>
                <span>技术支持：贵州唯捷众品信息科技有限公司</span>
            </p>
            <p>
                <span>贵公网安备52010302000533号</span>
            </p>
        </footer>
  </div>-->
  <div>
    <div id="footer">
      <div class="main">
        <div class="siteinfo">
          <p>版权所有：{{ footData.websiteName }}</p>
          <p>网站E-mail：{{ footData.websiteEmail }} 联系电话：{{ footData.websitePhone }}</p>
          <p>
            <a href="https://beian.miit.gov.cn/">{{ footData.recordInformation }}</a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52010302003188">
              <img
                style="height: 18px;width: 18px;display: inline-block"
                src="https://bxgz-image.v2gogo.com/image/2020/05/13/e951d530afb44a60aa010f4da81d7dfe.png"
              >贵公网安备 52010302003188号<!-- {{ footData.policeRecord }} -->
            </a>
          </p>
          <p>技术支持：贵州唯捷众品信息技术有限公司</p>
          <div style="margin:5px">
            <a href="/">网站首页</a> |
            <router-link to="/subPage?name=盟务要闻">盟务要闻</router-link>
          </div>
        </div>
        <a
          style="display: inline-block; position: absolute;top: 30px;right: 320px;width: 52px;height: 64px;"
          href="http://bszs.conac.cn/sitename?method=show&amp;id=2A5B577A47B44043E053022819AC23BF"
        >
          <img
            style="height: 100%;width: 100%;"
            src="https://bxgz-image.v2gogo.com/image/2020/05/13/f459f0ee31f342a9ae1704b42604c129.png"
            alt
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getFooter } from '@/api/common';
export default {
  name: 'Foot',
  data() {
    return {
      footData: {}
    };
  },
  created: function() {
    this.foot();
  },
  methods: {
    foot() {
      getFooter().then(res => {
        this.footData = res.data;
      })
    }
  }
};
</script>

<style lang="less" scoped>
#footer {
  height: 143px;
  background: #367dbe;
  background-size: cover;
  color: #fff;
  line-height: 26px;
  overflow: hidden;
  font-size: 12px;
  font-family: å®‹ä½“;
}
#footer .main {
  margin: 0 auto;
}
.main {
  width: 1200px;
  padding: 0;
  margin: 0 auto;
  position: relative;
}
#footer .main .siteinfo {
  height: 143px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  width: 1200px;
  overflow: hidden;
}
#footer a {
  color: #f3f3f3;
  font-size: 14px;
}
a {
  text-decoration: none;
  color: #484848;
}
a:hover,
a:focus {
  text-decoration: underline;
}
// .foot-box {
//   width: 100%;
//   min-width: 1200px;
//   background: #367dbe;

//   footer {
//     width: 1200px;
//     height: 145px;
//     text-align: center;
//     box-sizing: border-box;
//     padding: 10px 0;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: space-around;
//     p {
//       font-size: 12px;
//       color: #fff;
//     }
//     p:nth-child(1) {
//       font-size: 14px;
//     }
//   }
// }
</style>
